import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { simpleStrapiFetch } from './Strapi.api';

export interface UseSimpleStrapiFetchOptions {
  collection: string;
  populate?: string[];
  filters?: { [key: string]: string };
}

export const useSimpleStrapiFetch = <T>({
  collection,
  populate = [],
  filters = {}
}: UseSimpleStrapiFetchOptions) => {
  const { i18n } = useTranslation();
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const getContent = async () => {
      try {
        setLoading(true);
        const data = await simpleStrapiFetch<T>({
          collection,
          locale: i18n.language,
          populate,
          filters,
        });
        setData(data);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
      } finally {
        setLoading(false);
      }
    };

    getContent();
  }, [collection, i18n.language, JSON.stringify(populate), JSON.stringify(filters)]);

  return { data, loading, error };
};
